import CentroCustoIndex from "@/modules/CentroCusto/pages/Index";
import RelatorioCentroCusto from "@/modules/CentroCusto/pages/Relatorio";

export default [
  {
    name: "centrosCustos",
    path: "/centros-custos",
    component: CentroCustoIndex,
    meta: { title: "Centro de custos", permission: "centros-custos" },
  },
  {
    name: "relatorioCentrosCustos",
    path: "/centros-custos/relatorio",
    component: RelatorioCentroCusto,
    meta: {
      title: "Relatório por centro de custos",
      permission: "centros-custos",
    },
  },
];
